import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-prize-structure-mydico',
  templateUrl: './prize-structure-mydico.component.html',
  styleUrls: ['./prize-structure-mydico.component.scss'],
})
export class PrizeStructureMydicoComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private router: Router) { }
  urlPrev: any;
  ngOnInit() {
    this.urlPrev = localStorage.getItem('urlPrev');
  }

  async onBack() {
    const urlPrev = JSON.parse(localStorage.getItem('urlPrev'));
    if (urlPrev) {
      await this.router.navigate([urlPrev]);
    } else {

    }
  }
}
